var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPast90Days(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1544",
    "data-name": "Group 1544",
    transform: "translate(-739 -227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_968",
    "data-name": "Rectangle 968",
    transform: "translate(744 238)",
    fill: "#fff",
    stroke: "#5dadae",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 58,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 63,
    height: 56,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1536",
    "data-name": "Group 1536",
    transform: "translate(524 605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1536-2",
    "data-name": "Group 1536",
    transform: "translate(215 -378)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_967",
    "data-name": "Rectangle 967",
    width: 60.412,
    height: 41.31,
    transform: "translate(2.324 22.104)",
    fill: "#d6fffa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12099",
    "data-name": "Path 12099",
    d: "M10.094,387.419c0-.76-.036-1.46.006-2.156a5.119,5.119,0,0,1,10.212-.008c.044.717.007,1.438.007,2.185h8.36c0-.7-.033-1.395.006-2.085a5.115,5.115,0,0,1,9.831-1.641,11.084,11.084,0,0,1,.409,2.552,10.365,10.365,0,0,1,.008,1.2c1.34,0,2.593,0,3.847,0a4.655,4.655,0,0,1,4.955,4.95q0,24.1,0,48.2a4.649,4.649,0,0,1-4.9,4.933q-27.622,0-55.245,0a4.65,4.65,0,0,1-4.911-4.921q0-24.138,0-48.275a4.644,4.644,0,0,1,4.869-4.89c1.279,0,2.559,0,3.955,0,0-.746-.035-1.443.006-2.135a5.084,5.084,0,0,1,4.644-4.763A5.078,5.078,0,0,1,1.5,384.142a13.347,13.347,0,0,1,.251,2.511c.02.237,0,.476,0,.765ZM-15,402.606v.735q0,18.586,0,37.172a2.391,2.391,0,0,0,2.709,2.722H42.67c1.873,0,2.743-.877,2.743-2.761q0-18.55,0-37.1v-.769Zm60.412-2.388c0-2.615,0-5.176,0-7.736a2.378,2.378,0,0,0-2.67-2.688q-5.481,0-10.962,0h-.8a13.151,13.151,0,0,0,.012,1.562,5.112,5.112,0,0,0,.386,1.665,2.674,2.674,0,0,0,2.371,1.425,1.156,1.156,0,0,1,1.2,1.187,1.183,1.183,0,0,1-1.333,1.124,3.589,3.589,0,0,1-.506-.04,5.11,5.11,0,0,1-4.44-4.965c-.027-.64,0-1.283,0-1.913h-16.4a16.113,16.113,0,0,0,.462,3.023,2.555,2.555,0,0,0,2.477,1.588,1.16,1.16,0,0,1,1.141,1.174,1.181,1.181,0,0,1-1.257,1.133,3.645,3.645,0,0,1-.649-.057,5.1,5.1,0,0,1-4.357-4.961c-.026-.623,0-1.247,0-1.9H-6.2a12.451,12.451,0,0,0,.012,1.495,5.158,5.158,0,0,0,.378,1.668,2.673,2.673,0,0,0,2.363,1.439,1.178,1.178,0,0,1,1.2,1.191,1.2,1.2,0,0,1-1.342,1.12,3.741,3.741,0,0,1-.576-.058,5.093,5.093,0,0,1-4.347-4.969c-.025-.622,0-1.246,0-1.934-1.395,0-2.7-.007-4,0A2.337,2.337,0,0,0-15,392.3c-.008,1.863,0,3.727,0,5.59v2.331ZM-.625,387.431A18.081,18.081,0,0,0-.644,385.1a2.766,2.766,0,0,0-2.734-2.254,2.771,2.771,0,0,0-2.741,2.246,17.884,17.884,0,0,0-.019,2.337Zm13.075,0h5.512a17.852,17.852,0,0,0-.019-2.337,2.79,2.79,0,0,0-5.475.009A18.106,18.106,0,0,0,12.45,387.431Zm24.124.01c0-.762.054-1.465-.011-2.157a2.789,2.789,0,0,0-5.479-.3,15.352,15.352,0,0,0-.024,2.455Z",
    transform: "translate(17.323 -380.502)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12100",
    "data-name": "Path 12100",
    d: "M55.06,438.811H-5.352v-2.331c0-1.863-.006-3.726,0-5.59a2.337,2.337,0,0,1,2.489-2.5c1.3-.008,2.6,0,4,0,0,.688-.021,1.312,0,1.934a5.093,5.093,0,0,0,4.347,4.969,3.741,3.741,0,0,0,.576.058,1.2,1.2,0,0,0,1.342-1.12,1.178,1.178,0,0,0-1.2-1.191A2.673,2.673,0,0,1,3.842,431.6a5.158,5.158,0,0,1-.378-1.668,12.452,12.452,0,0,1-.012-1.495H19.726c0,.648-.022,1.273,0,1.9a5.1,5.1,0,0,0,4.357,4.961,3.642,3.642,0,0,0,.649.057,1.181,1.181,0,0,0,1.257-1.133,1.16,1.16,0,0,0-1.141-1.174,2.555,2.555,0,0,1-2.477-1.588,16.113,16.113,0,0,1-.462-3.023h16.4c0,.63-.023,1.272,0,1.913a5.11,5.11,0,0,0,4.44,4.965,3.6,3.6,0,0,0,.506.04,1.183,1.183,0,0,0,1.333-1.124,1.156,1.156,0,0,0-1.2-1.187,2.674,2.674,0,0,1-2.371-1.425,5.111,5.111,0,0,1-.386-1.665,13.151,13.151,0,0,1-.012-1.562h.8q5.481,0,10.962,0a2.378,2.378,0,0,1,2.67,2.688C55.062,433.636,55.06,436.2,55.06,438.811Z",
    transform: "translate(7.676 -419.095)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_90",
    "data-name": 90,
    transform: "translate(230.2 -328.2)",
    fill: "#5dadae",
    fontSize: 25,
    fontFamily: "RobotoMono-SemiBold, Roboto Mono",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "90"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPast90Days);
export default __webpack_public_path__ + "static/media/past-90days.3db3dc1dcdce92ba1a80c4f21d45504d.svg";
export { ForwardRef as ReactComponent };